import { useRef, useState } from 'react';

const useMedia = (...breakpoints) => {
  const [media, setMedia] = useState({});
  const mounted = useRef(false);

  // Media must be checked before component renders to avoid
  // unnecessary renders and state updates
  if (!mounted.current) {
    const initialMedia = {};
    breakpoints.forEach(([breakpoint, name]) => {
      if (typeof window === 'undefined') return;
      const browserMedia = window.matchMedia(breakpoint);
      initialMedia[name] = browserMedia.matches;
      browserMedia.onchange = () => {
        setMedia((prev) => ({
          ...prev,
          [name]: browserMedia.matches,
        }));
      };
    });
    setMedia(initialMedia);
    mounted.current = true;
  }

  return media;
};

export default useMedia;
